/**
 * @file useIsDesktop.ts
 *
 * @fileoverview Help determine if the user is in desktop using matchmedia.
 */

import { useIsMobile } from "./useIsMobile";
import { useIsTablet } from "./useIsTablet";

export const useIsDesktop = () => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return !isMobile && !isTablet;
};
